import { render, staticRenderFns } from "./fr_bel_ma_dz.vue?vue&type=template&id=1956465c&scoped=true"
import script from "./fr_bel_ma_dz.vue?vue&type=script&lang=js"
export * from "./fr_bel_ma_dz.vue?vue&type=script&lang=js"
import style0 from "./fr_bel_ma_dz.vue?vue&type=style&index=0&id=1956465c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956465c",
  null
  
)

export default component.exports